import {GenerationTypeEnum} from "../shared/types/GenerationTypeEnum.ts";
import {CustomVideoPreview} from "../shared/ui/CustomVideoPreview.tsx";
import {CustomImagePreview} from "../shared/ui/CustomImagePreview.tsx";

interface ICustomEffectPreviewWidgetProps {
    mediaType: GenerationTypeEnum;
    title: string;
    price: number;
    onChangeClick: () => void;
}

export const CustomEffectPreviewWidget = ({
    mediaType,
    title,
    price,
    onChangeClick
}: ICustomEffectPreviewWidgetProps) => {
    return mediaType === GenerationTypeEnum.VIDEO ? (
        <CustomVideoPreview title={title} price={price} onChangeClick={onChangeClick} />
    ) : (
        <CustomImagePreview title={title} price={price} onChangeClick={onChangeClick} />
    );
};
